module.exports = __webpack_public_path__ + "img/search.da2bb4fe.svg";